// extracted by mini-css-extract-plugin
export var active = "_5w-1";
export var activeSubdued = "_5w-2";
export var compact = "_5w-3";
export var pulse = "_5w-4";
export var settingHighlightPulse = "_5w-5";
export var wrapper = "_5w-0";